import classNames from "classnames";
import React from "react";

type ProductSectionDividerProps = {
  children: React.ReactNode;
  container?: boolean;
  className?: string;
  'data-workflow'?: string;
} & React.HTMLAttributes<HTMLDivElement>;

/**
 * A simple content divider for products, with a fixed bottom margin.
 *
 * @constructor
 */
export function ProductSectionDivider({
  container = true,
  className,
  children,
  ...props
}: ProductSectionDividerProps) {
  container = container === undefined ? true : container;
  className = className ?? undefined;
  return <div className={classNames(
    "mb-8 md:mb-20 lg:mb-28 scroll-m-28",
    {"container mx-auto px-6 lg:px-0": container},
    className,
  )} {...props}>{children}</div>
}
